import React from 'react';
import PropTypes from 'prop-types';

const CheckoutNav = ({ backButton, nextButton, className = '' }) => (
  <div className={`checkout-nav ${className}`.trim()}>
    <div className="checkout-nav__back">{backButton}</div>
    <div className="checkout-nav__next">{nextButton}</div>
  </div>
);

CheckoutNav.propTypes = {
  backButton: PropTypes.node,
  nextButton: PropTypes.node,
  className: PropTypes.string,
};

export default CheckoutNav;
